import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { captureCampaign, trackHealthcheck, trackPageView } from '@/lib/telemetry'
import { routeTemplate } from '@/lib/routeTemplate'

// Fires one anonymous sink hit per route change (and on initial load), carrying the current path,
// the matched route template, and the previous in-app path for journey tracking.
//
// The template (`app.route`) is the groupable half of a page view: `app.path` holds org slugs,
// module names and workspace keys, so it cannot be grouped on to answer "which screens get used".
export function usePageTracking() {
  const { pathname } = useLocation()
  const prev = useRef<string | null>(null)

  useEffect(() => {
    trackHealthcheck() // once-per-session baseline beacon (idempotent)
  }, [])

  useEffect(() => {
    captureCampaign() // first-load campaign capture (idempotent)
    trackPageView(pathname, prev.current ?? undefined, routeTemplate(pathname))
    prev.current = pathname
  }, [pathname]) // fire once per route change, not on query-only changes
}
